module.exports = __webpack_public_path__ + "img/22.58562a53.png";